import React, { useEffect, useState } from 'react';
import './OrderStatusSummary.scss';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { isNil, map } from 'lodash-es';
import classNames from 'classnames';
import { useGerOrderByIdQuery } from '../../../store/order/orderApi';
import { ensureDataUrl } from '../../../utils/imageHandlers';
import { IGetCustomizationGroupSelectionResponse } from '../../../proto/order/customizationGroupSelection';
import { getOrderItemFinalPrice } from '../../../utils/getOrderItemPrice.util';
import { EOrderItemStatus, eOrderItemStatusToJSON } from '../../../proto/order/orderItemStatus.enum';

interface IOrderStatusSummaryProps {
	onDismiss: () => void;
	isOpen: boolean;
	orderId: string;
}

export const OrderStatusSummary = ({ onDismiss, isOpen, orderId }: IOrderStatusSummaryProps): JSX.Element => {
	const [open, setOpen] = useState(false);
	const { data: order } = useGerOrderByIdQuery({ orderId }, { skip: isNil(orderId) });

	const onDismissSheet = (): void => {
		setOpen(false);
		onDismiss();
	};

	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	const getSelectionSummaryString = (selections: IGetCustomizationGroupSelectionResponse[]): string => {
		return map(selections, (selection) => {
			return selection?.name ?? '';
		}).join(', ');
	};

	const mapOrderStatusToString = (status: EOrderItemStatus): string => {
		switch (status) {
			case EOrderItemStatus.PENDING:
				return 'בהמתנה';
			case EOrderItemStatus.PREPARING:
				return 'בהכנה';
			case EOrderItemStatus.COMPLETED:
				return 'הושלם';
			case EOrderItemStatus.CANCELLED:
				return 'בוטל';
			default:
				return eOrderItemStatusToJSON(status);
		}
	};

	return (
		<div>
			<BottomSheet
				open={open}
				onDismiss={onDismissSheet}
				defaultSnap={({ snapPoints, lastSnap }): any => lastSnap ?? Math.min(...snapPoints)}
				snapPoints={({ maxHeight }): any => [maxHeight - maxHeight / 5, maxHeight]}
				header={<div>סטטוס הזמנה</div>}
				className="bottom-sheet-container"
				expandOnContentDrag={false}
			>
				<div className="bottom-sheet-content">
					<div className="cart-container">
						{map(order?.items, (orderItem) => (
							<div className="cart-item" key={orderItem.id}>
								<div className="cart-item-image-and-content">
									<div className="cart-item-image">
										<img src={ensureDataUrl(orderItem.image)} alt="title" />
									</div>
									<div className="cart-item-content">
										<div className="cart-item-title-and-quantity">
											<div className="cart-item-title">{orderItem.title}</div>
											<div className="cart-item-quantity">x{orderItem.quantity}</div>
										</div>
										<div className="cart-item-description">{orderItem.description}</div>
										{map(orderItem.customizationGroups, (customizationGroup) => (
											<div className="cart-item-option" key={customizationGroup.id}>
												<div className="cart-item-option-title">{customizationGroup.title}:</div>
												<div className="cart-item-option-selections">{getSelectionSummaryString(customizationGroup.selections)}</div>
											</div>
										))}
										<div className="cart-item-price">₪{getOrderItemFinalPrice(orderItem)}</div>
										<div className="cart-item-status-wrapper">
											<div className="cart-item-status">סטטוס:</div>
											<div className={classNames('cart-item-status-value', eOrderItemStatusToJSON(orderItem.status).toLowerCase())}>
												{mapOrderStatusToString(orderItem.status)}
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
					<div className="bottom-sheet-footer-transparent" />
				</div>
			</BottomSheet>
		</div>
	);
};
